<h2 mat-dialog-title translate>digitalSignatureDialog.title</h2>
<mat-dialog-content>
  <mat-grid-list cols="15" rowHeight="60px">
    <mat-grid-tile colspan="15" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="detailDigitalSignature__title">digitalSignatureDialog.dades</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.numSol</mat-label>
        <mat-label> {{ digitalSignatureDetailDTO.dataWeb.strNumSol }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.version</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.versionContract }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.nif</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.legalIdentity_id }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.name</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.firstname }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.lastname1</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.lastname1 }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.lastname2</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.lastname2 }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="10" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.email</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.email }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.mobile</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.mobile }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="3" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.creation_date</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.creation_date }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="3" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.cod_result</mat-label>
        <mat-label>{{ this.adminStore.getTextStatus(digitalSignatureDetailDTO.dataWeb.document_result) }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1" class="border-list"></mat-grid-tile>
    <mat-grid-tile colspan="15" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column" class="margin-text">
        <mat-label translate class="bold">digitalSignatureDialog.filename</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.filename }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="3" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.doc_result</mat-label>
        <mat-label>{{ this.adminStore.getTextStatus(digitalSignatureDetailDTO.dataWeb.document_result) }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="3" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.date_doc_result</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.document_result_date | date: 'dd/MM/yyyy' }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.finalState</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.final_state }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1" class="border-list">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.date_finalState</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.final_state_date }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="4" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.statePetition</mat-label>
        <mat-label>{{ this.adminStore.getTextStatus(digitalSignatureDetailDTO.dataWeb.strEstPeticion) }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.state_file</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataWeb.fileState }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="15" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="detailDigitalSignature__title">digitalSignatureDialog.state_logalty</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.doc_result</mat-label>
        <mat-label>{{
          this.adminStore.getTextStatus(digitalSignatureDetailDTO.dataLogalty.document_result)
        }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.finalState</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataLogalty.final_state }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.guid</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataLogalty.guid }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="15" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="detailDigitalSignature__title">digitalSignatureDialog.state_host</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.receptor</mat-label>
        <mat-label>{{ this.adminStore.getTextStatus(digitalSignatureDetailDTO.dataHost.document_result) }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.finalState</mat-label>
        <mat-label>{{ digitalSignatureDetailDTO.dataHost.final_state }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" rowspan="1">
      <div fxFlex fxLayout="column">
        <mat-label translate class="bold">digitalSignatureDialog.statePetition</mat-label>
        <mat-label>{{ this.adminStore.getTextStatus(digitalSignatureDetailDTO.dataHost.strEstPeticion) }}</mat-label>
      </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="15" rowspan="1">
      <mat-label fxFlex class="detailDigitalSignature__title" translate>digitalSignatureDialog.consents</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="15" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="digitalSignatureDetailDTO.consentsDTO.check_TDPFCFRSC === 'S'">
        <mat-label translate>digitalSignatureDialog.consentSabadell</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="15" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="digitalSignatureDetailDTO.consentsDTO.check_CDPFC === 'S'">
        <mat-label translate>digitalSignatureDialog.consentPersonalCommercial</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="15" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="digitalSignatureDetailDTO.consentsDTO.check_TDPFC === 'S'">
        <mat-label translate>digitalSignatureDialog.consentCommercial</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="15" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="digitalSignatureDetailDTO.consentsDTO.check_CBPDDEBP === 'S'">
        <mat-label translate>digitalSignatureDialog.consentBonPreu</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="15" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="digitalSignatureDetailDTO.consentsDTO.check_TDTGSS === 'S'">
        <mat-label translate>digitalSignatureDialog.consentTgss</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
  </mat-grid-list>
</mat-dialog-content>
